import axios from "axios";
import ReactDOM from "react-dom";
import { login } from "@/services/auth";
import { Spin } from "antd";
import intl from "react-intl-universal";

// form表单提交数据
export function formatForm(params) {
  let param = new URLSearchParams();
  for (let i in params) {
    param.append(i, params[i]);
  }
  return param;
}

// 截取url参数
export function getQueryVariable(variable) {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] === variable) {
      return pair[1];
    }
  }
  return false;
}

// 获取用户信息
export function getAdminInfoFun() {
  return new Promise((resolve, reject) => {
    login()
      .then((res) => {
        if (res.code === 0) {
          resolve(res.data);
        } else {
          console.log(res.message);
        }
      })
      .catch((err) => {});
  });
}

// 判断当前输入的是手机号还是邮箱
export function isPhoneOrEmail(account) {
  let type = 1; // 1 手机  2 邮箱
  if (account && account.indexOf("@") === -1) {
    type = 1;
  } else {
    type = 2;
  }

  return type;
}

//下拉框多选取值
export function newArrList(typeList, valueList, name) {
  let newValue = [];
  if (typeList && valueList) {
    typeList.forEach((item) => {
      valueList.forEach((item2) => {
        if (item.val == item2) {
          newValue.push(item.name);
        }
      });
    });
    return newValue;
  }
}

//计算出生日期距离今天的年龄
export function ageFun(str) {
  let date = new Date();
  let age;
  let Y = date.getFullYear() + "-";
  let M =
    (date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1) + "-";
  let D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
  let month = getMonthByBirthday(str, Y + M + D);
  age = month / 12;
  return parseInt(age);
}

function getMonthByBirthday(birth, startDate) {
  var month = 0;
  var nowYear = startDate.split("-")[0];
  var nowMonth = startDate.split("-")[1];
  var nowDay = startDate.split("-")[2].substr(0, 2);
  var birthYear = birth.split("-")[0];
  var birthMonth = birth.split("-")[1];
  var birthDay = birth.split("-")[2];

  var nowM = parseInt(nowYear) * 12 + parseInt(nowMonth);
  var birthM = parseInt(birthYear) * 12 + parseInt(birthMonth);

  if (new Date() < new Date(birth)) {
    month = -1; //返回-1 表示出生日期输入错误 晚于今天
  } else if (nowM == birthM) {
    month = 0; //当年当月生日
  } else {
    if (parseInt(nowDay) == parseInt(birthDay)) {
      month = nowM - birthM;
    } else if (parseInt(nowDay) > parseInt(birthDay)) {
      month = nowM - birthM + 0.1;
    } else {
      month = nowM - birthM - 0.1;
    }
  }
  return month;
}

export function scientificToNumber(num) {
  var str = num.toString();
  var reg = /^(\d+)(e)([\-]?\d+)$/;
  var arr,
    len,
    zero = "";

  /*6e7或6e+7 都会自动转换数值*/
  if (!reg.test(str)) {
    return num;
  } else {
    /*6e-7 需要手动转换*/
    arr = reg.exec(str);
    len = Math.abs(arr[3]) - 1;
    for (var i = 0; i < len; i++) {
      zero += "0";
    }
    return "0." + zero + arr[1];
  }
}

// 生成GUID
export function guid() {
  return "xxxxxxxx-xxxx-2xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;

    return v.toString(16);
  });
}

//随机选择颜色
function randomColor(arr) {
  var i = Math.floor(Math.random() * arr.length);
  return i;
}

export function bgColor(params) {
  var arr = ["#37C3FC", "#1890FF", "#EA5959", "#E29B3A", "#07B23C", "#4094B6"];
  return arr[randomColor(arr)];
}

// 判断当前登录设备
export function IsPc() {
  var ua = navigator.userAgent,
    isWindowsPhone = /(?:Windows Phone)/.test(ua),
    isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
    isAndroid = /(?:Android)/.test(ua),
    isFireFox = /(?:Firefox)/.test(ua),
    isChrome = /(?:Chrome|CriOS)/.test(ua),
    isTablet =
      /(?:iPad|PlayBook)/.test(ua) ||
      (isAndroid && !/(?:Mobile)/.test(ua)) ||
      (isFireFox && /(?:Tablet)/.test(ua)),
    isPhone = /(?:iPhone)/.test(ua) && !isTablet,
    isPc = !isPhone && !isAndroid && !isSymbian;
  return {
    isTablet: isTablet,
    isPhone: isPhone,
    isAndroid: isAndroid,
    isPc: isPc,
  };
}

/**
 * 向指定路径发送下载请求
 * @param{String} url 请求路径
 */
export function downLoadByUrl(url, type, method = "get", data = {}) {
  return axios({
    url,
    method,
    responseType: "blob",
    headers: {
      "dots-token":
        localStorage.getItem("dots-token") ||
        sessionStorage.getItem("dots-token"),
    },
    data,
  }).then((res) => {
    console.log(res);
    const fileName = res.headers["content-disposition"]
      .split(";")[1]
      .split("filename=")[1]
      .split(".")[0];
    const filestream = res.data; // 返回的文件流
    // {type: 'application/vnd.ms-excel'}指定对应文件类型为.XLS (.XLS的缩写就为application/vnd.ms-excel)
    const blob = new Blob([filestream], { type: type });
    const a = document.createElement("a");
    const href = window.URL.createObjectURL(blob); // 创建下载连接
    a.href = href;
    a.download = decodeURI(fileName);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a); // 下载完移除元素
    window.URL.revokeObjectURL(href); // 释放掉blob对象
  });
}

export function downloadFile(url, filename) {
  const link = document.createElement("a");
  link.href = url;
  link.download = filename; // 设置下载的文件名
  document.body.appendChild(link);
  link.click(); // 触发点击下载
  document.body.removeChild(link); // 移除元素
}

/** 判断文件是否是照片
 * @param path 文件path
 */
export function isImg(path) {
  if (
    path.includes(".jpg") ||
    path.includes(".jpeg") ||
    path.includes(".png") ||
    path.includes(".gif")
  ) {
    return true;
  } else {
    return false;
  }
}

/**
 * 判断两个数组是否相等
 * @param {数组A} arrayA
 * @param {数组B} arrayB
 * @returns
 */
export function arraysEqual(arrayA, arrayB) {
  if (!arrayA || !arrayB) return false;
  if (arrayA.length !== arrayB.length) return false;
  arrayA.sort((a, b) => a - b);
  arrayB.sort((a, b) => a - b);
  for (let i = 0; i < arrayA.length; i++) {
    if (arrayA[i] !== arrayB[i]) return false;
  }
  return true;
}

/**
 * 获取用户考试相关key的缓存value，如切屏次数，无操作时间等
 * [{historyId: string, switchTimes: number, timeout: boolean}]
 * @param {缓存key} key
 * @param {考试任务试卷历史id} hId
 */
export function getUserExamInfo(key, hId) {
  let storageList = localStorage.getItem("dots-examInfo");
  let value = undefined;
  if (storageList && storageList !== "null") {
    storageList = JSON.parse(storageList);
    const examUserInfo = storageList.filter((s) => s.historyId === hId).pop();
    if (examUserInfo) {
      value = examUserInfo[key];
    }
  }
  return value;
}

/**
 * 保存用户考试相关key的缓存value，如切屏次数，无操作时间等
 * [{historyId: string, switchTimes: number, timeout: boolean}]
 * @param {缓存key} key
 * @param {缓存value} value
 * @param {考试任务试卷历史id} hId
 */
export function saveUserExamInfo(key, value, hId) {
  let storageList = localStorage.getItem("dots-examInfo");
  let examUserInfo = undefined;
  if (storageList && storageList !== "null") {
    storageList = JSON.parse(storageList);
    examUserInfo = storageList.filter((s) => s.historyId === hId).pop();
    if (examUserInfo) {
      examUserInfo[key] = value;
    } else {
      examUserInfo = {};
      examUserInfo.historyId = hId;
      examUserInfo[key] = value;
      storageList.push(examUserInfo);
    }
  } else {
    storageList = [];
    examUserInfo = {};
    examUserInfo.historyId = hId;
    examUserInfo[key] = value;
    storageList.push(examUserInfo);
  }
  localStorage.setItem("dots-examInfo", JSON.stringify(storageList));
}

/**
 * 提交或重考后清除用户考试相关key的缓存value，如切屏次数，无操作时间等
 * [{historyId: string, switchTimes: number, timeout: boolean}]
 * @param {考试任务试卷历史id} hId
 */
export function clearUserExamInfo(hId) {
  let storageList = localStorage.getItem("dots-examInfo");
  let examUserInfo = undefined;
  if (storageList && storageList !== "null") {
    storageList = JSON.parse(storageList);
    examUserInfo = storageList.filter((s) => s.historyId !== hId);
    if (examUserInfo) {
      localStorage.setItem("dots-examInfo", JSON.stringify(examUserInfo));
      return;
    }
    localStorage.setItem("dots-examInfo", JSON.stringify([]));
  }
}

// 根据某个字段去重
export const uniqueArray = (array, name) => {
  if (array.length === 0) return;

  let returnArr = [];
  const map = {};
  array.forEach((item) => {
    if (!map[item[name]]) {
      map[item[name]] = item; // 如果当前属性值没有，则添加到map中
    }
  });
  returnArr = Object.values(map);
  return returnArr;
};

// 判断当前值是否为NaN
export function transNan(_data) {
  return isNaN(_data) ? 0 : _data;
}

// 当前正在请求的数量
let requestCount1 = 0;

// 显示loading
export function showLoading1() {
  if (requestCount1 === 0) {
    var dom = document.createElement("div");
    dom.setAttribute("id", "loading");
    document.body.appendChild(dom);
    ReactDOM.render(
      <Spin
        tip={intl.get("Loading_910b61fe-7e7f-2b70-a5ae-97e743818378")}
        size="large"
      />,
      dom,
    );
  }
  requestCount1++;
}

// 隐藏loading
export function hideLoading1() {
  requestCount1--;
  if (requestCount1 === 0) {
    document.body.removeChild(document.getElementById("loading"));
  }
}

export function isBrowserMaximized() {
  // 检查各种浏览器环境
  const isChrome = !!window.chrome;
  const isFirefox = typeof InstallTrigger !== "undefined";
  const isEdge = !!window.StyleMedia;
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  const outerWidth = window.outerWidth;
  const outerHeight = window.outerHeight;
  const screenAvailWidth = window.screen.availWidth;
  const screenAvailHeight = window.screen.availHeight;

  // 不同浏览器的容差设置
  let tolerance = 10;

  if (isChrome) {
    // Chrome 可能需要更大的容差
    tolerance = 15;
  } else if (isFirefox) {
    // Firefox 的边框较厚
    tolerance = 20;
  } else if (isSafari) {
    // Safari 的UI占用较多
    tolerance = 25;
  }

  return (
    Math.abs(outerWidth - screenAvailWidth) <= tolerance &&
    Math.abs(outerHeight - screenAvailHeight) <= tolerance
  );
}

export function isImageName(name) {
  return name.match(/\.(jpeg|jpg|png|webp)$/i);
}

export function isMobile() {
  const ua = navigator.userAgent;

  // Android 手机/平板、iPhone、传统 iPad
  if (
    /Android|iPhone|iPad|iPod|webOS|BlackBerry|IEMobile|Opera Mini/i.test(ua)
  ) {
    return true;
  }

  // iPadOS 13+ 可能使用 Macintosh UA
  if (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1) {
    return true;
  }

  return false;
}

/**
 * OCR 文本归一化：去掉不可见字符与全角空格，全角 ASCII 转半角，中文句号转半角句点，
 * 大写转小写，并压缩连续空白。用于结算名称与发票销方等比对前的预处理。
 * 全角括号、冒号、逗号落在全角 ASCII 区间内，随全角转半角一并处理。
 *
 * @param {string} text - 待归一化的原始文本；空值按空字符串处理
 * @returns {string} 归一化后的小写文本
 */
export function normalizeOCRText(text) {
  if (!text) return "";

  return text
    .replace(/[\u200b\u3000\ufeff]/g, "")
    .replace(/[\uff01-\uff5e]/g, (ch) =>
      String.fromCharCode(ch.charCodeAt(0) - 0xfee0)
    )
    .replace(/。/g, ".")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();
}
